import React from 'react';
import { Button, Input } from 'semantic-ui-react';
import $ from "jquery";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Server from '../../../functions/server';

class Voucher extends React.Component {

    state = {
        
    }

    submit() {
        let context = this;
        $.ajax({
            type: 'POST', data: { id: context.props.id },
            url: Server()+'machine/receipt/cancel.php',
            success: function(data) {
                console.log(data);
                console.log('datatatat');
                if (data == 1) {
                    context.setState({ openDialog: false })
                    context.props.refreshData();
                }
            },
            error: function(e) {
                alert('Try again!!')
            }
        });
    }

    render() {
        let sino = 1;
        return (
            <div>
                <div onClick={ () => { this.setState({ openDialog: true }) }}>Cancel</div>
                <Dialog fullWidth={true} maxWidth={'sm'} open={this.state.openDialog}
                onClose={ () => { this.setState({ openDialog: false }) }}
                aria-labelledby="max-width-dialog-title" >
                <DialogTitle id="max-width-dialog-title">Confimation</DialogTitle>
                    <DialogContent>
                        Sure to delete this transaction?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ openDialog: false }) }}>No</Button>
                        <Button onClick={this.submit.bind(this)}>Yes</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default Voucher;
